import { FicheImplantation_DemandeDuplicata } from '@/domain/FicheImplantation_DemandeDuplicata'
import { Sexe, Sexe_ToText } from '@/domain/Sexe'
import { TraitementDuplicataFicheImpantation_Statut, TraitementDuplicataFicheImpantation_Statut_ToText } from '@/domain/TraitementDuplicataFicheImpantation_Statut'
import { TraitementFicheImplantation_Statut, TraitementFicheImplantation_Statut_ToText } from '@/domain/TraitementFicheImplantation_Statut'
import mobileTypeMixin from '@/global/mobile/mobileTypeMixin'
import mixins from 'vue-typed-mixins'
import globalMixin from '../globalMixin'
import ficheImplantation from './models/ficheImplantation'
import SendDuplicataModel from './models/ficheImplantationDuplicata_EnvoiMail'

export default mixins(globalMixin, mobileTypeMixin).extend({
    methods: {
        //////////////////// FICHES UTILISATEURS //////////////
        ajouterFichier(files: any) {
            if (!files.length) return

            const formData = new FormData()
            for (const f of files) {
                formData.append('files', f, f.name)
            }
            this.$loader.go()
            this.$http
                .api(`ficheImplantation/file`)
                .post(formData)
                .then(() => this.$swal.toast.success("La fiche d'implantation a été correctement envoyée."))
                .catch(x => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
        },

        saveDemandeDuplication(demandeDuplicata: FicheImplantation_DemandeDuplicata) {
            this.$loader.go()
            return this.$http
                .api(`ficheImplantation/demande-duplicata`)
                .post(demandeDuplicata)
                .then(x => {
                    x.data ? this.$swal.toast.success('La demande a été correctement envoyée.') : this.$swal.confirm.noCancel('Le numéro de greffon est invalide mais la demande a été correctement envoyée.', '', "J'ai compris")
                })
                .catch(x => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
        },

        //////////////////// FICHES ADMIN /////////////////////
        /** [API - GET] Recupération des demandes de duplicata */
        getDemandesDatatable(): Promise<any> {
            return this.$http
                .api(`ficheImplantation/all-demandes`)
                .get()
                .then(x => x.data)
                .catch(x => this.$swal.toast.errorApi(x))
        },
        /** [API - GET] Récupération des fiches d'implantations */
        getFichesDatatable(): Promise<any> {
            return this.$http
                .api(`ficheImplantation/all-fiches`)
                .get()
                .then(x => x.data)
                .catch(x => this.$swal.toast.errorApi(x))
        },
        /** [API - POST] Modification du statut d'une fiche d'implantations */
        modificationStatutFiche(id: number, statut: TraitementFicheImplantation_Statut) {
            return this.$http
                .api('ficheImplantation/traiter-fiche')
                .post({ id: id, statut: statut })
                .then(() => {
                    this.loadPastilles()
                    this.$swal.toast.success("La fiche d'implantation a bien été mise à jour.")
                })
                .catch(x => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
        },
        /** [API - POST] Modification d'une demande de duplicata d'une fiche d'implantations */
        modificationStatutDemande(id: number, statut: TraitementDuplicataFicheImpantation_Statut) {
            return this.$http
                .api('ficheImplantation/traiter-demande')
                .post({ id: id, statut: statut })
                .then(() => {
                    this.loadPastilles()
                    this.$swal.toast.success('La demande de duplicata a bien été mise à jour.')
                })
                .catch(x => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
        },
        /** [API - POST] Envoi mail pour duplicata de fiche d'implantation */
        envoyerMailDuplicataFicheImplantation(envoiMailDuplicata: SendDuplicataModel) {
            const formData = new FormData()
            formData.append('idDemandeDuplicata', envoiMailDuplicata.idDemandeDuplicata.toString())
            formData.append('mail', envoiMailDuplicata.mail)

            if (!envoiMailDuplicata.corps) {
                this.$swal.toast.error('Aucun corps renseigné.')
                return
            }
            formData.append('corps', envoiMailDuplicata.corps)

            if (!envoiMailDuplicata.files?.length) {
                this.$swal.toast.error('Aucun fichier renseigné.')
            }
            if (envoiMailDuplicata.files.length) {
                for (const file of envoiMailDuplicata.files) {
                    formData.append('files', file)
                }
            }
            return this.$http
                .api('ficheImplantation/envoyer-duplicata')
                .post(formData)
                .then(() => this.$swal.toast.success("L'envoi du duplicata de FI a bien été envoyé."))
                .catch(x => this.$swal.toast.errorApi(x))
        },

        ////////////// METHODES DE FORMATAGE VISUELLES //////////
        patientName(patient: any): string {
            return patient.nomPatient + ' ' + patient.prenomPatient
        },
        formatStatutFiche(fiche: ficheImplantation) {
            return TraitementFicheImplantation_Statut_ToText(fiche.statut)
        },
        colorStatutFiche(fiche: ficheImplantation) {
            return fiche.statut == TraitementFicheImplantation_Statut.EnAttenteDeTraitement ? 'info' : fiche.statut == TraitementFicheImplantation_Statut.EnCoursDeTraitement ? 'warning' : 'success'
        },
        formatDate(date: Date) {
            return new Date(date).toLocaleDateString('fr-FR')
        },
        formatSexe(sexe: Sexe) {
            return Sexe_ToText(sexe)
        },
        formatStatutDemande(demande: FicheImplantation_DemandeDuplicata) {
            return TraitementDuplicataFicheImpantation_Statut_ToText(demande.statut)
        },
        colorStatutDemande(demande: FicheImplantation_DemandeDuplicata) {
            return demande.statut == TraitementDuplicataFicheImpantation_Statut.EnAttenteDeTraitement ? 'info' : demande.statut == TraitementDuplicataFicheImpantation_Statut.EnCoursDeTraitement ? 'warning' : 'success'
        }
    }
})
